import { combineReducers } from 'redux'
import UserReducer from '../Store/UserReducer'
import ReportReducer from '../Store/ReportReducer'

const mainReducer = combineReducers({
    user: UserReducer,
    report: ReportReducer
});

export default mainReducer;